import { HGLELProduct, HGLNGProduct } from 'features/simulation/types'
import { Language } from './language'

// ENUMS

export enum PricelistTypes {
  RESIDENTIAL = 'res',
  PROFESSIONAL = 'pro'
}

// TYPES

export type AllProducts = {
  electricity: {
    [key in HGLELProduct]: ProductData
  }
  gas: {
    [key in HGLNGProduct]: ProductData
  }
}

export type PriceListUrls = {
  [key in Language]: string
}

export type ProductData = {
  details: ProductDetails
  pricelists: ProductPriceListUrls
}

export type ProductDetails = {
  id: string
  code: string
  description: string
  priceExplanation: string
  platformCost: number
  slug: string
  serverLocation: string
  version: number
}

export type ProductPriceListUrls = {
  [key in PricelistTypes]: PriceListUrls
}
